module.exports = __webpack_public_path__ + "static/media/12.0efd75db.jpg";